
export default{
  getActiveApi : process.env.VUE_APP_API_PREFIX + '/hd/large/activity/info',//活动数据
  getInfoBase: process.env.VUE_APP_API_PREFIX + '/api-passport/user/info/base', //获取用户信息
  getWxConfig: process.env.VUE_APP_API_PREFIX + '/hd/six-one-eight/wx-share' //微信分享 
}